// Vuetify 3 field rules, replacing vee-validate 2.

// vee-validate 2 treated an empty array as absent, and `v-select` with `multiple` yields one.
const isEmpty = (v) => v === null || v === undefined || v === '' || (Array.isArray(v) && !v.length)

export const required = (field) => (v) => !isEmpty(v) || `The ${field} field is required`

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const email = (field) => (v) =>
  isEmpty(v) || EMAIL.test(String(v).trim()) || `The ${field} field must be a valid email`

export const checked = (field) => (v) => v === true || `The ${field} field is required`
